import React from 'react'
import PropTypes from 'prop-types'
import styles from './_privacyStyles.css'

function SectionContent (props) {
  const { children } = props

  return (<div className={styles.sectionContent}>{ children }</div>)
}

SectionContent.propTypes = {
  children: PropTypes.object,
}

export default SectionContent



// WEBPACK FOOTER //
// ./src/components/privacy_center/util/SectionContent.jsx